import React, { useContext } from "react";
import { useLocation } from "react-router-dom";
import { languageKey } from "../../../constants/static";
import { webAndMobilePrivacyURL } from "../../../constants/urls";
import { StateContext } from "../../../context/stateContext";
import { useFetch } from "../../../hooks/useFetch";
import { IURLAssetReference } from "../../../interfaces/urlAssetReference";
import { translations } from "../../../translate";
import utils from "../../../utils/helperFunction";
import ParentFragmentHTML from "../../lib/ParentFragmentHTML";
import LegalAndPrivacyContainer from "../legalAndPrivacyContainer/LegalAndPrivacyContainer";

const WebAndMobilePrivacy = () => {
  const { cidmUrl, stateUSACode, languageCode } = useContext(StateContext);
  const { getStateName } = utils;
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  searchParams.set("name", "terms-of-use");
  const URL = `${cidmUrl}${webAndMobilePrivacyURL(languageCode)}/${getStateName(
    stateUSACode
  )}&experience/language/${languageCode}&content/dam/hcsc/common/manage-my-account/unauthenticated-legal-and-privacy/${
    languageKey[languageCode]
  }/${getStateName(stateUSACode)}-general/registration/unauthenticated/web-and-mobile-privacy-statement`;
  const { data, loading } = useFetch<{ urlAssetReferences: IURLAssetReference[] }>(URL);

  return (
    <LegalAndPrivacyContainer title={translations.webAndMobile[languageCode]}>
      {!loading && <ParentFragmentHTML data={data?.urlAssetReferences} />}
    </LegalAndPrivacyContainer>
  );
};

export default WebAndMobilePrivacy;
